import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LeadPopup from "./components/LeadPopup";
import Landing from "./pages/Landing";
import Marketplace from "./pages/Marketplace";
import TutorProfile from "./pages/TutorProfile";
import Admin from "./pages/Admin";
import BookingSuccess from "./pages/BookingSuccess";
import ParentDashboard from "./pages/ParentDashboard";
import NotFound from "./pages/NotFound";
import { pageMeta } from "./data/content";

const updateMetaTag = (selector, value, attribute = "content") => {
  const node = document.querySelector(selector);
  if (node && value) {
    node.setAttribute(attribute, value);
  }
};

const RouteEffects = () => {
  const location = useLocation();

  useEffect(() => {
    const meta = pageMeta[location.pathname] || pageMeta.default;
    document.title = meta.title;
    updateMetaTag('meta[name="description"]', meta.description);
    updateMetaTag('meta[property="og:title"]', meta.title);
    updateMetaTag('meta[property="og:description"]', meta.description);
    updateMetaTag('meta[name="twitter:title"]', meta.title);
    updateMetaTag('meta[name="twitter:description"]', meta.description);
    updateMetaTag('link[rel="canonical"]', `https://dreameer.in${location.pathname}`, "href");

    if (location.hash) {
      window.setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 60);
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname, location.hash]);

  return null;
};

export default function App() {
  return (
    <div className="min-h-screen bg-transparent text-ink">
      <RouteEffects />
      <LeadPopup />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/marketplace" element={<Marketplace />} />
          <Route path="/tutor/:id" element={<TutorProfile />} />
          <Route path="/booking-success" element={<BookingSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/parent-dashboard" element={<ParentDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
